import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";


interface LeftViewState {

  showOverlay: boolean;
};

const initialState: LeftViewState = {

    // selectedTab: "",
    showOverlay: false,
};

const leftViewSlice = createSlice({
  name: "leftView",
  initialState,
  reducers: {
    setShowOverlay: (state, action: PayloadAction<boolean>) => {
      state.showOverlay = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const {  setShowOverlay } = leftViewSlice.actions;
export const selectLeftView = (state: any) => state.leftView;
export default leftViewSlice.reducer;